module.exports = __webpack_public_path__ + "static/Owl Insights-2ffdc884f051d3f32786531f5ec979e0.jpg";